// @ts-ignore
import LottieVuePlayer from "@lottiefiles/vue-lottie-player";
import Vue from "vue";

Vue.use(LottieVuePlayer);
